import { toDate, format } from 'date-fns-tz'
import logger from '@/utils/logger'

export function convertToLocalTime(timeString) {
  if (!timeString) {
    return '';
  }

  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDate = toDate(`${timeString}Z`, { timeZone: 'UTC' });
    const formattedTime = format(utcDate, 'yyyy-MM-dd HH:mm:ss', { timeZone });
    return formattedTime;
  } catch (error) {
    logger.error('Error converting time:', error)
    return '';
  }
}



const TimeService = {
  convertToLocalTime
};

export default TimeService;
